<div class="container">
  <div class="type-change">
    <nz-button-group>
      <button
        nz-button
        [nzType]="taskType ? 'default' : 'primary'"
        (click)="orderTypeChange(0)"
      >
        <!-- 活跃订单 -->
        {{ "order.orderbox_active_order" | translate }}
      </button>
      <button
        nz-button
        [nzType]="taskType ? 'primary' : 'default'"
        (click)="orderTypeChange(1)"
      >
        <!-- 历史订单 -->
        {{ "order.orderbox_history_order" | translate }}
      </button>
    </nz-button-group>
  </div>
  <nz-spin [nzSpinning]="loading">
    <div class="notify" *ngIf="displayNotify && taskType === 0">
      <div class="icon">
        <img src="/assets/icon/orderbox_info.png" />
      </div>
      <div class="text">
        <p>
          {{ "order.orderbox_info" | translate }}
        </p>
      </div>
      <div class="cancel" (click)="closeNotify()">
        x
      </div>
    </div>
    <div *ngIf="list.length > 0">
      <div *ngFor="let data of list">
        <div class="list-container">
          <div class="background">
            <div class="username">
              <div class="left">
                <span class="customer">
                  {{ data?.thirdparty_customer?.name }}
                </span>
                <div class="thirdtype">
                  <div class="condition" *ngIf="data?.thirdparty_type === 5">
                    <div class="flag">
                      <div class="flag-text">
                        {{ "order.handmade_order" | translate }}
                      </div>
                    </div>
                    <div class="thirdparty">
                      <div class="thirdparty-text">
                        {{ getChannel(data?.handmade_chanel) }}
                      </div>
                    </div>
                  </div>
                  <div class="condition" *ngIf="data?.thirdparty_type !== 5">
                    <div class="thirdparty">
                      <div class="thirdparty-text">
                        {{
                          "word.channel_" + data?.thirdparty_type | translate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="right"
                (click)="showDetails((data?.reservations)[0]?.code)"
              >
                {{ "word.view_details" | translate }} >
              </div>
            </div>
            <div class="middle">
              <div class="left">
                <img
                  hostPlaceholder
                  [delaySrc]="
                    (data?.reservations)[0]?.house?.cover_url?.small_url
                  "
                  src="/assets/status/placeholder.png"
                  [attr.data-src]="
                    (data?.reservations)[0]?.house?.cover_url?.small_url
                  "
                />
                <div class="house-status" [style.background]="data.background">
                  <p>
                    {{
                      "order_status." + (data?.reservations)[0]?.out_status
                        | translate
                    }}
                  </p>
                </div>
              </div>
              <div class="right">
                <span
                  class="title"
                  *ngIf="
                    (data?.reservations)[0]?.exceptions.length === 0;
                    else noHouseTitle
                  "
                >
                  {{
                    (data?.reservations)[0]?.house?.title === ""
                      ? "-"
                      : ((data?.reservations)[0]?.house?.title | ellipsis: 20)
                  }}
                </span>
                <ng-template #noHouseTitle>
                  <span class="title">{{
                    "order.house_type_contains_no_houses"
                      | translate
                        : {
                            houseType:
                              ((data?.reservations)[0]?.exceptions)[0]?.title
                          }
                  }}</span>
                </ng-template>
                <div class="detail">
                  <div
                    [attr.title]="
                      (data?.reservations)[0]?.house?.house_type?.title
                    "
                  >
                    {{
                      (data?.reservations)[0]?.house?.house_type?.title
                        | ellipsis: 20
                    }}
                  </div>
                  <div
                    class="bar"
                    *ngIf="(data?.reservations)[0]?.house?.house_type?.title"
                  >
                    |
                  </div>
                  <div>
                    {{ data?.total_nights }}
                    {{
                      (data?.total_nights > 1 ? "word.nights" : "word.night")
                        | translate
                    }}
                  </div>
                  <div class="bar">|</div>
                  <div>
                    {{ data?.number_of_guests || 1 }}
                    {{
                      (data?.number_of_guests > 1
                        ? "word.total_people"
                        : "word.total_person"
                      ) | translate
                    }}
                  </div>
                  <div
                    style="padding-left: 24px;"
                    *ngIf="!(data?.reservations)[0]?.is_hour_reservation"
                  >
                    {{ data?.check_in | dateformat: ["MD"] }} ~
                    {{ data?.check_out | dateformat: ["MD"] }}
                  </div>
                  <div
                    style="padding-left: 24px;"
                    *ngIf="(data?.reservations)[0]?.is_hour_reservation"
                  >
                    {{ data?.check_in | dateformat: ["MD"] }}
                  </div>
                  <div class="money">
                    <p>
                      {{ data?.house_fee?.currency_type | currencyToSymbol }}
                    </p>
                    <p>{{ data?.house_fee?.amount }}</p>
                  </div>
                </div>
                <div class="time-row">
                  <div
                    class="time"
                    *ngIf="
                      (data?.reservations)[0]?.reservation_checkin_time
                        ?.check_in_time
                    "
                  >
                    {{ "order.arrive" | translate }}
                    {{ data?.check_in_time | dateformat: [null, "hm"] }}
                  </div>
                  <div
                    class="time"
                    *ngIf="
                      (data?.reservations)[0]?.reservation_checkin_time
                        ?.check_out_time
                    "
                  >
                    {{ "order.leave" | translate }}
                    {{ data?.check_out_time | dateformat: [null, "hm"] }}
                  </div>
                </div>
                <div
                  class="flags"
                  *ngIf="
                    (data?.reservations)[0]?.conflict_label?.is_conflict ||
                    data?.tags.length > 0
                  "
                >
                  <div
                    class="hour-order-label"
                    *ngIf="(data?.reservations)[0]?.is_hour_reservation"
                  >
                    <!-- 小时单 -->
                    <p>{{ "order_status.hour_reservation" | translate }}</p>
                  </div>
                  <div
                    *ngIf="(data?.reservations)[0]?.conflict_label?.is_conflict"
                    class="conflict"
                  >
                    <p class="conflict-text">
                      {{ "order.conflict_order" | translate }}
                    </p>
                  </div>
                  <div *ngFor="let tag of data?.tags">
                    <div *ngIf="tag.id !== 1" class="tag">
                      <div class="title" [style.background]="tag.color">
                        {{ tag.tag_name }}
                      </div>
                      <img
                        src="/assets/status/cancel-label.png"
                        class="delete"
                        [style.background]="tag.color"
                        (click)="deleteTag(tag)"
                      />
                    </div>
                  </div>
                  <div
                    class="check-in-label"
                    *ngIf="(data?.reservations)[0]?.tip_client_checked_in"
                  >
                    <p>
                      <!-- 已登记 -->
                      {{ "order.checked" | translate }}
                    </p>
                  </div>
                  <div
                    class="check-in-label"
                    *ngIf="(data?.reservations)[0]?.tip_no_lock_password"
                  >
                    <p>
                      <!-- 无门锁密码 -->
                      {{ "order.no_lock_password" | translate }}
                    </p>
                  </div>
                  <div
                    class="check-in-label"
                    *ngIf="(data?.reservations)[0]?.tip_no_auditing"
                  >
                    <p>
                      <!-- 未审核 -->
                      {{ "order.no_auditing" | translate }}
                    </p>
                  </div>
                </div>
                <div class="note" *ngIf="(data?.reservations)[0]?.note !== ''">
                  {{ "order.guest_remarks" | translate
                  }}{{ (data?.reservations)[0]?.note }}
                </div>
              </div>
            </div>
            <div class="bottom">
              <div class="left">
                <div class="cash">
                  <div
                    class="label"
                    [innerHTML]="
                      'order.list_total_house_fee' | translate
                    "
                  ></div>
                  <div class="text">
                    <p>{{ data?.currency_type | currencyToSymbol }}</p>
                    <p>{{ data?.house_fee?.amount }}</p>
                  </div>
                  <div
                    class="text"
                    [innerHTML]="'word.open_parenthesis' | translate"
                  ></div>
                  <div class="owe" *ngIf="data?.settlement?.status === 1">
                    <p>
                      {{ "order.owe_a_fee" | translate }}
                      {{ data?.currency_type | currencyToSymbol }}
                    </p>
                    <p>{{ data?.settlement?.less }}</p>
                  </div>
                  <div
                    class="cleared"
                    *ngIf="[0, 2].includes(data?.settlement?.status)"
                  >
                    {{ "order.money_cleared" | translate }}
                  </div>
                  <div
                    class="text"
                    [innerHTML]="'word.close_parenthesis' | translate"
                  ></div>
                </div>
                <div class="book-time">
                  <span
                    class="label"
                    [innerHTML]="
                      'order.booked_time' | translate
                    "
                  ></span>
                  <span class="text">{{ data?.booked_time | dateformat }}</span>
                </div>
              </div>
              <div class="right">
                <div
                  *ngIf="
                    taskType === 0 &&
                    (data?.reservations)[0]?.reservation_box?.is_ignored === 0
                  "
                >
                  <button
                    nz-button
                    (click)="ignore((data?.reservations)[0]?.code, 1)"
                  >
                    {{ "order.orderbox_ignore" | translate }}
                  </button>
                </div>
                <div
                  *ngIf="
                    taskType === 0 &&
                    (data?.reservations)[0]?.reservation_box?.is_ignored === 1
                  "
                >
                  <button
                    nz-button
                    (click)="ignore((data?.reservations)[0]?.code, 0)"
                  >
                    {{ "order.orderbox_recovery_remind" | translate }}
                  </button>
                </div>
                <!-- <div
                  class="button"
                  *ngIf="data?.thread_id && data?.thirdparty_type !== 5"
                >
                  <button
                    nz-button
                    nzType="default"
                    (click)="contact(data.thread_id)"
                  >
                    联系房客
                  </button>
                </div> -->
                <div class="button">
                  <button
                    nz-button
                    nzType="primary"
                    (click)="orderChangeRoom((data?.reservations)[0]?.code)"
                  >
                    {{ "order.order_change_house_1" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <nz-pagination
          [(nzPageIndex)]="pageIndex"
          [nzTotal]="pageTotal || 0"
          [nzPageSize]="20"
          (nzPageIndexChange)="pageChange()"
        >
        </nz-pagination>
      </div>
    </div>
    <div *ngIf="list.length === 0" class="none">
      <img class="host-no-data-img-large" src="/assets/icon/no_data.png" />
      <p class="text">{{ "order.no_order" | translate }}</p>
    </div>
  </nz-spin>
</div>

<ng-template #ignoreTemplate>
  <div class="host-ignore">
    <div class="title">
      <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
      <p>{{ "warning.order.confirm_ignore_order" | translate }}</p>
    </div>
    <div class="content">
      {{ "warning.order.ignore_order_info" | translate }}
    </div>
    <div class="operate">
      <label
        nz-checkbox
        [(ngModel)]="notshowIgnoreModal"
        (ngModelChange)="showIgnoreModalChange()"
      >
        {{ "word.no_longer_prompt_1" | translate }}
      </label>
      <div class="button">
        <button nz-button (click)="closeIgnoreModal()">
          {{ "word.cancel" | translate }}
        </button>
        <button
          nz-button
          style="margin-left: 8px;"
          nzType="primary"
          (click)="confirmIgnore(ignoreReservationId, 1)"
        >
          {{ "word.confirm" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
